export function disableInvalidOptions<T extends Record<string, any>>(
  dateTabKey: keyof T,
  mapping: T | undefined,
  hasDateColumn: boolean,
  hasTimelineColumn: boolean
) {
  if (mapping) {
    const newMapping = { ...mapping };
    if (!hasDateColumn && hasTimelineColumn) {
      newMapping[dateTabKey] = "timeline" as T[keyof T];
    }
    if (hasDateColumn && !hasTimelineColumn) {
      newMapping[dateTabKey] = "start-end" as T[keyof T];
    }
    if (!hasDateColumn && !hasTimelineColumn) {
      newMapping[dateTabKey] = "" as T[keyof T];
    }
    return newMapping;
  }
  return mapping;
}
